import type { RouteRecordRaw } from "vue-router"
import { useSessionStore } from "@versatile-credit-apply/sdk"

export const ResumeRoutes: RouteRecordRaw[] = [
  {
    path: "/resume",
    components: {
      layout: () => import("@/components/layout/PlainLayout.vue"),
    },
    children: [
      {
        path: "",
        redirect(to) {
          const store = useSessionStore()
          const resumeType =
            store.waterfallResume != undefined ? "waterfall" : "provider"

          return `${to.fullPath}/${resumeType}`
        },
      },
      {
        path: "provider",
        component: () => import("./ProviderResumePage.vue"),
      },
      {
        path: "waterfall",
        children: [
          {
            path: "",
            component: () => import("./WaterfallResumePage.vue"),
            beforeEnter: (to) => {
              const session = useSessionStore()
              const status = session.waterfallResume?.waterfallStatus

              // No need to wait for a waterfall, the initial start response
              // has everything we need.
              if (status === "completed" || status === "expired") {
                return {
                  path: `${to.fullPath}/${status}`,
                  replace: true,
                }
              }
            },
          },
          {
            path: "completed",
            component: () => import("./WaterfallCompletedPage.vue"),
          },
          {
            path: "expired",
            redirect() {
              const session = useSessionStore()

              return {
                path: `/${session.flowType}/workflows/pre-provider`,
                replace: true,
              }
            },
          },
        ],
      },
    ],
  },
]
